export default "__VITE_ASSET__BAQZvv6l__"